module.exports = __webpack_public_path__ + "static/media/art1.f59a57d5.png";